module.exports = __webpack_public_path__ + "img/sHolyGoat_350x350.cb946bcd.jpg";